<div
  #iconElement
  class="property"
  [ngStyle]="{
    'background-color': property.markerColor,
    '--border-color': property.markerColor
  }"
  (click)="toggleHighlight()"
>
  <div class="icon">
    <img *ngIf="!property.icon" [src]="getIconPath(property.type)" [title]="property.type" #iconElement />
    <img *ngIf="property.icon" [src]="property.icon" alt="icon" />
    <span class="fa-sr-only">{{ property.type }}</span>
  </div>
  <div class="details" *ngIf="property.distance">
    <div class="price">{{ property.price }}</div>
    <div class="address">{{ property.address }}</div>
    <div class="features"*ngIf="property.distance.distance">
      <div *ngIf="property.distance.distance.Km">
        <span>{{ property.distance.distance.Km }} Km</span>
      </div>
      <div
        *ngIf="property.distance.distance.M "
      >
        <span>{{ property.distance.distance.M }} m</span>
      </div>
      <div *ngIf="property.distance.hours && property.distance.hours > 0">
        <span>{{ property.distance.hours }} Hours </span>
      </div>
      <div *ngIf="property.distance.minutes && property.distance.minutes > 0">
        <span>{{ property.distance.minutes }} Min</span>
      </div>
    </div>
  </div>
</div>
